import { render } from "./PositiveQuery.vue?vue&type=template&id=f4f47e6c"
import script from "./PositiveQuery.vue?vue&type=script&lang=js"
export * from "./PositiveQuery.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__